<div class="dialog-form">
  <form (submit)="save($event)" [formGroup]="customerForm">
    <p-fieldset legend="Informações Pessoais">
      <div style="display: flex; justify-content: space-between; align-items: flex-start;">
        <div style="display: flex; flex-wrap: wrap; flex-grow: 1; gap: 16px;">
          <div class="form-group" style="flex: 1 1 20%;">
            <div class="form-control">
              <label for="name">Nome do Cliente *</label>
              <input style="margin-top: -8px;" pInputText name="name" formControlName="name" maxlength="255"
                placeholder="Digite o nome do cliente" [pTooltip]="getErrorTooltip(customerForm.get('name'))" />
              <small *ngIf="submitted && customerForm?.controls?.name?.errors?.required" class="p-error block">
                Nome Obrigatório
              </small>
            </div>
          </div>

          <div class="form-group" style="flex: 1 1 20%;">
            <div class="form-control">
              <label for="country">País emissor do documento *</label>
              <p-dropdown [options]="countries" formControlName="nationality" appendTo="body"
                (onChange)="onNationalityChange()" [pTooltip]="getErrorTooltip(customerForm.get('nationality'))">
              </p-dropdown>
              <small *ngIf="submitted && customerForm?.controls?.nationality?.errors?.required" class="p-error block">
                Nacionalidade Obrigatória
              </small>
            </div>
          </div>

          <div class="form-group" style="flex: 1 1 20%;">
            <div class="form-control">
              <label>Tipo de Documento Fiscal *</label>
              <p-dropdown [options]="federalIdTypeOptions" formControlName="federalIdType" placeholder="Selecione o tipo">
              </p-dropdown>
            </div>
          </div>

          <div class="form-group" style="flex: 1 1 20%;">
            <div class="form-control">
              <label for="federalId">Número de Documento Fiscal *</label>
              <!-- Input com máscara para CPF -->
              <p-inputMask *ngIf="isBrazilianNationality && customerForm?.get('federalIdType')?.value === 'Physical'"
                mask="999.999.999-99" formControlName="federalId" placeholder="Digite o número do CPF"
                [pTooltip]="getErrorTooltip(customerForm.get('federalId'))">
              </p-inputMask>

              <!-- Input com máscara para CNPJ (alfanumérico: 12 primeiras posições A-Z/0-9, 2 DV numéricos) -->
              <p-inputMask *ngIf="isBrazilianNationality && customerForm?.get('federalIdType')?.value === 'Juridical'"
                mask="**.***.***/****-99" formControlName="federalId" placeholder="Digite o número do CNPJ"
                styleClass="uppercase-input"
                [pTooltip]="getErrorTooltip(customerForm.get('federalId'))">
              </p-inputMask>

              <!-- Input simples para estrangeiros - MODIFICADO -->
              <input *ngIf="!isBrazilianNationality" pInputText type="text" formControlName="federalId"
                placeholder="Digite o número do documento" [pTooltip]="getErrorTooltip(customerForm.get('federalId'))"
                maxlength="50" [value]="customerForm.get('federalId').value">

              <div class="flex-row-between">
                <small *ngIf="shouldShowError('federalId', 'required')" class="p-error block">
                  Documento Obrigatório
                </small>
                <div class="invalid"></div>
                <small *ngIf="isBrazilianNationality && shouldShowError('federalId', 'invalidFederalId')"
                  class="p-error block">
                  Documento Inválido
                </small>
              </div>
            </div>
          </div>
        </div>

        <div class="photo-wrapper" style="margin-left: 16px;">
          <app-sailor-upload
            [path]="imgPreviewPhoto"
            title="Foto"
            (finishEvent)="receiveUploadUrlPhoto($event)">
          </app-sailor-upload>
        </div>
      </div>

      <div class="form-group flex-row-between access-phone-row">

      <div class="form-group" style="flex: 1 1 30px; margin-top: 1px;">
        <div class="form-control">
          <label for="accessGroup">Grupo de Acesso *</label>
          <p-dropdown [options]="accessGroupOptions" formControlName="accessGroup" optionLabel="label" appendTo="body"
            placeholder="Selecione um grupo de acesso" [showClear]="true"
            [pTooltip]="getErrorTooltip(customerForm.get('accessGroup'))" (onChange)="validateRequiredFields()"
            tooltipPosition="bottom" [optionValue]="'value'">
          </p-dropdown>
          <small *ngIf="submitted && customerForm?.controls?.accessGroup?.errors?.required" class="p-error block">
            Grupo de Acesso Obrigatório
          </small>
        </div>
      </div>

      <div class="form-group" style="flex: 1 1 30px; margin-top: 1px;">
        <div class="form-control">
          <label for="codRegistration">Matrícula</label>
          <input pInputText type="text" formControlName="codRegistration" autocomplete="off">
        </div>
      </div>
        <div class="form-control phone-control">
          <label class="phone-label">Telefone *</label>
          <div class="phone-input-container">
            <p-dropdown [options]="countryCodes" formControlName="phoneCountry" optionLabel="name" [showClear]="false"
              [filter]="true" filterBy="name,dialCode" (onChange)="onCountrySelect($event.value)" [placeholder]="'DDI'"
              [style]="{'width': '100%'}">
              <ng-template let-country pTemplate="item">
                <div style="display: flex; align-items: center; gap: 8px;">
                  <span>{{ country.flag }}</span>
                  <span>{{ country.dialCode }}</span>
                  <span>{{ country.name }}</span>
                </div>
              </ng-template>
            </p-dropdown>

            <div style="display: block;">
              <input pInputText formControlName="phoneNumber" [placeholder]="selectedCountry.placeholder"
                (input)="applyPhoneMask($event)" style="width: 100%;">
              <small *ngIf="submitted && customerForm?.controls?.phoneNumber?.errors?.required && isWorkshop"
                class="p-error block">
                Telefone Obrigatório
              </small>
            </div>
          </div>
        </div>
      </div>




      <div class="form-group flex-row-between" style="width: 100%; margin-left: 0">

        <div class="form-control" style="width: 25%;">
          <label for="email">E-mail *</label>
          <p-chips [(ngModel)]="emailValues" [ngModelOptions]="{standalone: true}"
            (ngModelChange)="updateEmailFormControl()" [placeholder]="'Adicione emails e pressione Enter'" separator=";"
            [addOnBlur]="true" [allowDuplicate]="false" [inputStyle]="{'width':'100%'}">
          </p-chips>
          <input type="hidden" formControlName="email"> <!-- Keep the form connection -->
          <small
            *ngIf="submitted && (customerForm?.controls?.email?.errors?.required || customerForm?.controls?.email?.errors?.invalidEmail)"
            class="p-error block">
            Pelo menos um e-mail válido é obrigatório
          </small>
        </div>

        <div class="form-control switch">
          <label style="min-width: 100px;  white-space: nowrap; max-height: 25px; padding-bottom: 8px; ">E-mail
            Faturamento</label>
          <p-inputSwitch [(ngModel)]="useEmailCollection" [ngModelOptions]="{standalone: true}"
            (onChange)="toggleEmailCollection()"></p-inputSwitch>

        </div>

        <div class="form-control" style="width: 25%; padding-top: 19px;" *ngIf="useEmailCollection">
          <label for="emailCollection"></label>
          <p-chips [(ngModel)]="emailCollectionValues" [ngModelOptions]="{standalone: true}"
            (ngModelChange)="updateEmailCollectionFormControl()" [placeholder]="'Adicione emails e pressione Enter'"
            separator=";" [addOnBlur]="true" [allowDuplicate]="false" [inputStyle]="{'width':'100%'}">
          </p-chips>
          <input type="hidden" formControlName="emailCollection">
          <small *ngIf="submitted && useEmailCollection && customerForm?.controls?.emailCollection?.errors"
            class="p-error block">
            <span *ngIf="customerForm?.controls?.emailCollection?.errors?.required">
              Campo obrigatório
            </span>
            <span *ngIf="customerForm?.controls?.emailCollection?.errors?.invalidEmail">
              Pelo menos um e-mail válido é obrigatório
            </span>
          </small>
        </div>



      </div>







      <div class="form-group" style=" margin-bottom: 0px; width: 100%; margin-left: 0; height: 50px; margin-top: -8px;">


        <div class="form-control" style="width: 25%;">
          <label for="group">Grupo de Faturamento *</label>
          <p-dropdown [options]="groups" formControlName="group" appendTo="body"
            placeholder="Digite o grupo do faturamento">
          </p-dropdown>
          <small *ngIf="customerForm?.controls?.group?.touched && customerForm?.controls?.group?.errors?.required"
            class="p-error block">
            Grupo de Faturamento Obrigatório
          </small>
        </div>
        <div class="form-control" style="width: 25%;">
          <label for="billingDay">Data de Início de Faturamento *</label>
          <p-calendar dateFormat="dd/mm/yy" formControlName="billingDay" [showIcon]="true"
            placeholder="Selecione o início do faturamento" [monthNavigator]="true" [yearNavigator]="true"
            [showTime]="false">
          </p-calendar>
          <small
            *ngIf="customerForm?.controls?.billingDay?.touched && customerForm?.controls?.billingDay?.errors?.required"
            class="p-error block">
            Início de Faturamento Obrigatório
          </small>
        </div>
        <div class="form-control" style="width: 25%;">
          <label for="dueDate">Dia Vencimento *</label>
          <p-dropdown [options]="availableDays" formControlName="dueDate" appendTo="body"
            placeholder="Selecione o dia de vencimento" [pTooltip]="getErrorTooltip(customerForm.get('dueDate'))">
          </p-dropdown>
          <small *ngIf="submitted && customerForm?.controls?.dueDate?.errors?.required" class="p-error block">
            Dia de Vencimento Obrigatório
          </small>
        </div>

      </div>
    </p-fieldset>
    <div style="height: 20px; margin-bottom: 0px;"></div>
    <!-- Endereço -->
    <p-fieldset legend="Endereço" style="padding-top: 15px;">
      <div formGroupName="address" class="form-group" style="margin-bottom: -10px;">
        <div class="form-control">
          <label for="country">País *</label>
          <p-dropdown [options]="countries" formControlName="country" appendTo="body"
            (onChange)="onAddressCountryChange($event)"
            [pTooltip]="getErrorTooltip(customerForm.get('address.country'))">
          </p-dropdown>
          <small *ngIf="submitted && customerForm?.get('address')?.controls?.country?.errors?.required"
            class="p-error block">
            País Obrigatório
          </small>
        </div>

        <div class="form-control">
          <label for="zip">{{ isBrazilianAddress ? 'CEP' : 'Código Postal' }} *</label>
          <!-- Input com máscara para Brasil -->
          <p-inputMask *ngIf="isBrazilianAddress " mask="99999-999" formControlName="zip" (onBlur)="getCep()"
            placeholder="Digite o CEP" [pTooltip]="getErrorTooltip(customerForm.get('address.zip'))">
          </p-inputMask>
          <!-- Input simples para outros países -->
          <input *ngIf="!isBrazilianAddress " pInputText type="text" formControlName="zip"
            placeholder="Digite o código postal" [pTooltip]="getErrorTooltip(customerForm.get('address.zip'))">
          <small *ngIf="submitted && customerForm.get('address.zip')?.errors?.required" class="p-error block">
            {{ isBrazilian ? 'CEP' : 'Código Postal' }} Obrigatório
          </small>
        </div>
        <div class="form-control">
          <label for="state">{{ isBrazilianAddress ? 'UF' : 'Estado/Província' }} *</label>
          <!-- Dropdown para Brasil -->
          <p-dropdown *ngIf="isBrazilianAddress " [options]="states" formControlName="state" appendTo="body"
            placeholder="Selecione a Unidade Federativa" (onChange)="loadCities()"
            [pTooltip]="getErrorTooltip(customerForm.get('address.state'))">
          </p-dropdown>
          <!-- Input simples para outros países -->
          <input *ngIf="!isBrazilianAddress " pInputText type="text" formControlName="state"
            placeholder="Digite o estado ou província" [pTooltip]="getErrorTooltip(customerForm.get('address.state'))">
          <small *ngIf="submitted && customerForm.get('address.state')?.errors?.required" class="p-error block">
            {{ isBrazilian ? 'UF' : 'Estado/Província' }} Obrigatório
          </small>
        </div>

        <div class="form-control">
          <label for="city">Cidade *</label>
          <p-autoComplete formControlName="city" [suggestions]="filteredCities" (completeMethod)="filterCities($event)"
            appendTo="body" placeholder="Digite a cidade"
            [pTooltip]="getErrorTooltip(customerForm.get('address.city'))">
          </p-autoComplete>
          <small *ngIf="submitted && customerForm.get('address.city')?.errors?.required" class="p-error block">
            Cidade Obrigatória
          </small>
        </div>
      </div>



      <div formGroupName="address" class="form-group" style="margin-bottom: -45px;">
        <div class="form-control">
          <label for="district">Bairro *</label>
          <input pInputText formControlName="district" placeholder="Digite o nome do bairro" />
          <small
            *ngIf="(submitted || customerForm.get('address.district')?.touched) && customerForm.get('address.district')?.errors?.required"
            class="p-error block">
            Bairro Obrigatório
          </small>
        </div>
        <div class="form-control">
          <label for="street">Rua *</label>
          <input pInputText formControlName="street" placeholder="Digite o nome da rua"
            [pTooltip]="getErrorTooltip(customerForm.get('address.street'))" />
          <small
            *ngIf="(submitted || customerForm.get('address.street')?.touched) && customerForm.get('address.street')?.errors?.required"
            class="p-error block">
            Rua Obrigatória
          </small>
        </div>

        <div class="form-control">
          <label for="number">Número *</label>
          <input pInputText type="text" formControlName="number" placeholder="Digite o número da casa"
            [pTooltip]="getErrorTooltip(customerForm.get('address.number'))" />
          <small
            *ngIf="(submitted || customerForm.get('address.number')?.touched) && customerForm.get('address.number')?.errors?.required"
            class="p-error block">
            Número Obrigatório
          </small>
        </div>
        <div class="form-control">
          <label for="complement">Complemento</label>
          <input pInputText formControlName="complement" placeholder="Digite o complemento (opcional)" />
        </div>
      </div>

      <div class="form-group">
      </div>
    </p-fieldset>

    <div class="">
      <div class="buttons">
        <p-button class="save-button" label="Salvar" type="submit"></p-button>
      </div>
    </div>
  </form>
</div>
